import { useEffect, useState } from "react";
import { administrationRequests } from "api/administrationApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

// Loads the category of the selected discipline (Regular / Sport / ForeignLanguage).
// Returns null while there is no discipline, the hook is disabled, the request is pending or it failed.
export const useDisciplineCategory = (disciplineId, { enabled = true } = {}) => {
  const [disciplineCategory, setDisciplineCategory] = useState(null);
  const notifyError = useNotifyError();

  useEffect(() => {
    setDisciplineCategory(null);
    if (!disciplineId || !enabled) return;

    let isStale = false;
    const fetchDisciplineCategory = async () => {
      try {
        const { data } = await dataProvider.customRequest(
          administrationRequests.getDisciplineById(disciplineId),
          null,
          "GET",
        );
        if (!isStale) setDisciplineCategory(data?.category ?? null);
      } catch (err) {
        if (!isStale) notifyError(err);
      }
    };
    fetchDisciplineCategory();

    return () => {
      isStale = true;
    };
  }, [disciplineId, enabled, notifyError]);

  return disciplineCategory;
};
